// removed by extract-text-webpack-plugin
module.exports = {"dot":"style__dot___2JIre","wrapper":"style__wrapper___3fejT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/signup-ads-instagram-carousel-indicators/style.css
// module id = 843
// module chunks = 0